

// Create PaymentIntent with installments
export const createPaymentIntent = async (amount, paymentMethodId = null, customerData = null) => {
    try {
        const requestBody = {
            amount,
            payment_method_id: paymentMethodId,
            currency: "mxn",
            return_url: `${window.location.origin}/confirmation`,
            automatic_payment_methods: {
                enabled: true,
                allow_redirects: 'never'
            }
        };

        // Add customer data if provided
        if (customerData) {
            requestBody.customer_name = customerData.customer_name;
            requestBody.customer_email = customerData.customer_email;
            requestBody.customer_phone = customerData.customer_phone;
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/stripe/create-payment-intent`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error creating payment intent:', error);
        throw error;
    }
};

// Confirm payment with selected plan
export const confirmPayment = async (paymentIntentId, selectedPlan) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/stripe/confirm-payment`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                payment_intent_id: paymentIntentId,
                selected_plan: selectedPlan,
                return_url: `${window.location.origin}/confirmation`
            })
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error confirming payment:', error);
        throw error;
    }
};

// Check installment availability
export const checkInstallmentAvailability = async (amount, paymentMethodId = null) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/stripe/create-payment-intent`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                amount,
                payment_method_id: paymentMethodId
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return {
            installmentsEnabled: data.installmentsEnabled || false,
            availablePlans: data.availablePlans || [],
            availableInstallments: data.availableInstallments || []
        };
    } catch (error) {
        console.error('Error checking installments:', error);
        return {
            installmentsEnabled: false,
            availablePlans: [],
            availableInstallments: []
        };
    }
}; 